import { STATIC_PLANS } from '../data/staticPlans';
import type { PlanConfig } from '../services/subscriptionService';

/** Quick amounts the top-up form offers; amounts under the plan's minimum are left out. */
const QUICK_TOP_UP_AMOUNTS = [50, 100, 200, 500];

/**
 * Smallest credit top-up the plan sells. Checkout refuses less, because a smaller
 * amount would be priced under the card processors' minimum charge.
 */
export const getMinimumTopUpCredits = (plans: Record<string, PlanConfig>, planId: string): number => (
  plans[planId]?.minimum_topup_credits ?? STATIC_PLANS[planId]?.minimum_topup_credits ?? 1
);

/** Three quick amounts, the first at or above the plan's minimum. */
export const getQuickTopUpAmounts = (minimum: number): number[] => {
  const amounts = QUICK_TOP_UP_AMOUNTS.filter((amount) => amount >= minimum);

  return amounts.length >= 3 ? amounts.slice(0, 3) : [minimum, minimum * 2, minimum * 4];
};

/**
 * What checkout charges for a top-up: credits × rate rounded half-up to the cent
 * (or paisa), exactly as the backend rounds it. toFixed(4) first drops the
 * floating-point noise that would otherwise round 7296.5 paise down.
 */
export const topUpCharge = (credits: number, rate: number): number => (
  Math.round(Number((credits * rate * 100).toFixed(4))) / 100
);
